import React, { useState, useEffect } from "react";
import { KpiSpinner } from "./KpiIcons";
import { apiCall } from "../../../../_services/apiCall";
import config from "../../../../config/config";
import { Modal, ModalHeader } from "../../../../globalComponents/ui/Modal";
import { SecondaryButton } from "../../../../globalComponents/ui/Button";

const AuditTrailModal = ({ show, onHide, item, financialYearId }) => {
  const [trail, setTrail] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show || !item?.id || !financialYearId) return;

    const fetchTrail = async () => {
      setLoading(true);
      try {
        const { isSuccess, data } = await apiCall(
          `${config.POSTLOGIN_API_URL_COMPANY}getKpiAuditTrail`,
          {},
          {
            questionId: item.id,
            financialYearId, // 🔥 ALWAYS CURRENT FY
          },
          "GET"
        );

        if (isSuccess) {
          setTrail(data?.data || []);
        } else {
          setTrail([]);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchTrail();
  }, [
    show,
    item?.id,
    financialYearId, // 🔥 THIS WAS MISSING
  ]);
  const fmt = (d) =>
    d ? new Date(d).toLocaleDateString("en-GB") : "—";

  return (
    <Modal show={show} onClose={onHide} maxWidth={900}>
      <ModalHeader
        emoji="🛡️"
        title="Audit History Trail"
        subtitle={item?.kpi_name}
        onClose={onHide}
      />

      <div style={{ padding: 24 }}>
        {loading ? (
          <KpiSpinner label="Fetching audit trail..." />
        ) : trail.length ? (
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {trail.map((a, idx) => (
              <div
                key={idx}
                style={{
                  background: "#f8fafc",
                  padding: 16,
                  borderRadius: 10,
                  border: "1px solid #e2e8f0",
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr 2fr",
                  gap: 12,
                }}
              >
                <Field label="Audited By" value={a.auditorName} />
                <Field label="Date" value={fmt(a.auditedDate)} />
                <Field
                  label="Status"
                  value={
                    <span
                      style={{
                        fontWeight: 700,
                        color:
                          a.status === "ACCEPTED"
                            ? "#16a34a"
                            : "#dc2626",
                      }}
                    >
                      {a.status}
                    </span>
                  }
                />
                <Field label="Remark" value={a.remark || "—"} />
              </div>
            ))}
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: 40, color: "#64748b" }}>
            No audit history found.
          </div>
        )}
      </div>

      <div style={{ padding: "0 24px 24px", textAlign: "right" }}>
        <SecondaryButton onClick={onHide}>
          Close
        </SecondaryButton>
      </div>
    </Modal>
  );
};

const Field = ({ label, value }) => (
  <div>
    <div
      style={{
        fontSize: 10,
        fontWeight: 700,
        color: "#64748b",
        marginBottom: 4,
      }}
    >
      {label}
    </div>
    <div style={{ fontSize: 12, fontWeight: 600 }}>
      {value || "—"}
    </div>
  </div>
);

export default AuditTrailModal;